webpackJsonp([35783957827783],{

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/divider1.54cd32c8.jpg";

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cw.469a2aa2.jpg";

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(40);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _sortBy = __webpack_require__(44);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reactHelmet = __webpack_require__(49);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _cw = __webpack_require__(181);
	
	var _cw2 = _interopRequireDefault(_cw);
	
	var _divider = __webpack_require__(179);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*import { Timeline } from 'react-twitter-widgets' */
	
	var HeaderComplete = function (_React$Component) {
	  _inherits(HeaderComplete, _React$Component);
	
	  function HeaderComplete() {
	    _classCallCheck(this, HeaderComplete);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  HeaderComplete.prototype.render = function render() {
	    /* console.log("props", this.props)
	     const pageLinks = []
	     const site = get(this, 'props.data.site.siteMetadata') */
	    return _react2.default.createElement(
	      'div',
	      { id: 'headerwrap', name: 'home', style: { backgroundImage: 'url(' + _divider2.default + ')' } },
	      _react2.default.createElement(
	        'header',
	        { className: 'clearfix' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement('span', { className: 'icon icon-w' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Christian Wolter'
	        )
	      )
	    );
	  };
	
	  return HeaderComplete;
	}(_react2.default.Component);
	
	var imgStyle = {
	  margin: '0px auto'
	};
	
	var Footer = function (_React$Component2) {
	  _inherits(Footer, _React$Component2);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
	    _this2.state = {
	      intervalId: 0
	    };
	    return _this2;
	  }
	
	  Footer.prototype.scrollStep = function scrollStep() {
	    if (window.pageYOffset === 0) {
	      clearInterval(this.state.intervalId);
	    }
	    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
	  };
	
	  Footer.prototype.scrollToTop = function scrollToTop() {
	    var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
	    this.setState({ intervalId: intervalId });
	  };
	
	  Footer.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { id: 'footerwrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'created by Christian Wolter - copyright 2019 - ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/imprint', onClick: function onClick() {
	                    _this3.scrollToTop();
	                  } },
	                'imprint | disclaimer'
	              ),
	              ' -  ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/privacy', onClick: function onClick() {
	                    _this3.scrollToTop();
	                  } },
	                'privacy'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	var ScrollButton = function (_React$Component3) {
	  _inherits(ScrollButton, _React$Component3);
	
	  function ScrollButton() {
	    _classCallCheck(this, ScrollButton);
	
	    var _this4 = _possibleConstructorReturn(this, _React$Component3.call(this));
	
	    _this4.state = {
	      intervalId: 0
	    };
	    return _this4;
	  }
	
	  ScrollButton.prototype.scrollStep = function scrollStep() {
	    if (window.pageYOffset === 0) {
	      clearInterval(this.state.intervalId);
	    }
	    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
	  };
	
	  ScrollButton.prototype.scrollToTop = function scrollToTop() {
	    var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
	    this.setState({ intervalId: intervalId });
	  };
	
	  ScrollButton.prototype.render = function render() {
	    var _this5 = this;
	
	    return _react2.default.createElement(
	      'button',
	      { title: 'Back to top', className: 'scroll',
	        onClick: function onClick() {
	          _this5.scrollToTop();
	        } },
	      _react2.default.createElement('span', { className: 'arrow-up glyphicon glyphicon-chevron-up' })
	    );
	  };
	
	  return ScrollButton;
	}(_react2.default.Component);
	
	var PageIndex = function (_React$Component4) {
	  _inherits(PageIndex, _React$Component4);
	
	  function PageIndex() {
	    _classCallCheck(this, PageIndex);
	
	    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
	  }
	
	  PageIndex.prototype.render = function render() {
	    // console.log("props", this.props)
	    // const pageLinks = []
	    // const site = get(this, 'props.data.site.siteMetadata')
	    // const posts = get(this, 'props.data.remark.posts')
	    // const sortedPosts = sortBy(posts, post =>
	    //   get(post, 'post.frontmatter.date')
	    // ).reverse()
	    //
	    // sortedPosts.forEach((data, i) => {
	    //   if (
	    //     data.post.frontmatter.layout === 'post' &&
	    //     data.post.path !== '/404/'
	    //   ) {
	    //     pageLinks.push(
	    //       <SitePost data={data.post} site={site} isIndex={true} key={i} />
	    //     )
	    //   }
	    // })
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(HeaderComplete, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'container', id: 'about', name: 'about' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row white' },
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'h1',
	            { className: 'centered' },
	            'about me'
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'row white' },
	          _react2.default.createElement('div', { className: 'col-md-5 col-sm-4 col-xs-4' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-2 col-sm-4 col-xs-4' },
	            _react2.default.createElement('img', { src: _cw2.default, alt: 'CW', className: 'img-circle img-responsive', style: imgStyle })
	          ),
	          _react2.default.createElement('div', { className: 'col-md-5 col-sm-4 col-xs-4' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row white' },
	          _react2.default.createElement('div', { className: 'col-md-2' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8' },
	            _react2.default.createElement(
	              'p',
	              { className: 'centered' },
	              'Digital native, startup mind, hobbyist programmer',
	              _react2.default.createElement('br', null),
	              'innovation management enthusiast'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'centered' },
	              'Born in the 80s in Hanover ',
	              _react2.default.createElement(
	                'small',
	                null,
	                '(Hannover)'
	              ),
	              ', Germany',
	              _react2.default.createElement('br', null),
	              'Since 2009 based in Nuremberg ',
	              _react2.default.createElement(
	                'small',
	                null,
	                '(N\xFCrnberg)'
	              ),
	              ', Germany'
	            )
	          ),
	          _react2.default.createElement('div', { className: 'col-md-2' })
	        )
	      ),
	      _react2.default.createElement(ScrollButton, { scrollStepInPx: '50', delayInMs: '16.66' }),
	      _react2.default.createElement(Footer, null)
	    );
	  };
	
	  return PageIndex;
	}(_react2.default.Component);
	
	exports.default = PageIndex;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-c52cc92f66832370a8e0.js